import { render, staticRenderFns } from "./ScreeCompany.vue?vue&type=template&id=17e1359f&scoped=true&"
import script from "./ScreeCompany.vue?vue&type=script&lang=js&"
export * from "./ScreeCompany.vue?vue&type=script&lang=js&"
import style0 from "./ScreeCompany.vue?vue&type=style&index=0&id=17e1359f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e1359f",
  null
  
)

export default component.exports